module.exports = __webpack_public_path__ + "img/checklist_light.e698916d.svg";